import * as React from 'react';

import { cn } from '@/lib/shadcn/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import { iconWithBackgroundVariants } from './icon-with-background-variants';

interface IconWithBackgroundProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof iconWithBackgroundVariants> {
  icon: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  asChild?: boolean;
}

const IconWithBackground = React.forwardRef<HTMLDivElement, IconWithBackgroundProps>(
  ({ icon, size, iconSize, variant, className, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'div';
    return (
      <Comp
        ref={ref}
        className={cn(iconWithBackgroundVariants({ size, iconSize, variant, className }))}
        {...props}
      >
        {icon}
      </Comp>
    );
  },
);
IconWithBackground.displayName = 'IconWithBackground';

export { IconWithBackground };
